module.exports = __webpack_public_path__ + "img/2FABackupCodeInput_new.a1b565c.png";